import { compose, setDisplayName, withStateHandlers } from 'recompose';
import omitProps from '@hocs/omit-props';
import { RefObject, useCallback, useRef } from 'react';

export interface IWithFirst {
  isFirst: boolean;

  setFirst(value: boolean): void;
}

export interface IOuter {}

const state = new Map<any, boolean>();

export const clearIsFirstState = () => {
  state.clear();
};

/**
 * @deprecated as we are moving from HOCs to hooks, please use `useFirst` if possible
 */
export const withFirst = (key) =>
  compose<IWithFirst, IOuter>(
    setDisplayName(`withFirst(${key})`),
    withStateHandlers(
      () => {
        if (!state.has(key)) {
          state.set(key, true);
        }
        return { isFirst: state.get(key) };
      },
      {
        setFirst: () => (isFirst) => {
          state.set(key, isFirst);
          return { isFirst };
        },
      },
    ),
  );

/**
 * @deprecated as we are moving from HOCs to hooks, please use `useFirst` if possible
 */
export const withoutFirst = compose(setDisplayName('withoutFirst'), omitProps('isFirst', 'setFirst'));

export const useFirst = (key: string): [RefObject<boolean>, (isFirst: boolean) => void] => {
  if (!state.has(key)) {
    state.set(key, true);
  }
  const isFirst = useRef<boolean>(state.get(key));

  const setFirst = useCallback((_isFirst) => {
    state.set(key, _isFirst);
    isFirst.current = _isFirst;
  }, []);

  return [isFirst, setFirst];
};
